import { useCallback, useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

export interface CrmMappingCoverage {
  advisersTotal: number;
  advisersMapped: number;
  lendersObserved: number;
  lendersMapped: number;
}

interface UseCrmMappingCoverageState {
  coverage: CrmMappingCoverage | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useCrmMappingCoverage(
  companyId: string | undefined
): UseCrmMappingCoverageState {
  const [coverage, setCoverage] = useState<CrmMappingCoverage | null>(null);
  const [loading, setLoading] = useState<boolean>(Boolean(companyId));
  const [error, setError] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState<number>(0);

  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  useEffect(() => {
    if (!companyId) {
      setLoading(false);
      return;
    }
    const fn = httpsCallable<{ companyId: string }, CrmMappingCoverage>(
      functions,
      'getCrmMappingCoverage'
    );
    setLoading(true);
    setError(null);
    fn({ companyId })
      .then((r) => setCoverage(r.data))
      .catch((err) => {
        console.error('[useCrmMappingCoverage] fetch failed', err);
        setError(err instanceof Error ? err.message : String(err));
      })
      .finally(() => setLoading(false));
  }, [companyId, refreshKey]);

  return { coverage, loading, error, refresh };
}
